import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  TextField,
  Grid,
  Container,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import ShepButton from "@/components/GenericComponents/ShepButton";
import { useDispatch } from "react-redux";
import { handleAddCatalog } from "@/features/connections/manageCatalogDataSlice";
import { defaultCode } from "@/features/connections/integrationSlice";
import axios from "@/features/axiosHelper";
//SHEP-940 Duplicate of AddItemUOMPopup with a couple tweaks
//required since the original required being used within a grid
//removed redux states and grid context

const EmailAddItemUOMPopup = ({
  open,
  onClose,
  onSuccess,
  initialUOM = "",
  itemCode = "",
  itemId = null,
  connectionId,
  connectionName = "",
  artifactType = 2008,
}) => {
  const dispatch = useDispatch();
  const [dataValues, setDataValues] = useState({});

  useEffect(() => {
    if (open) {
      setDataValues({ UOM: initialUOM });
    }
  }, [open, initialUOM]);

  const validateForm = () => {
    if (!itemCode || itemCode.trim() === "") {
      return { isValid: false, message: "Item Code is missing." };
    }
    if (!dataValues.UOM || dataValues.UOM.trim() === "") {
      return { isValid: false, message: "UOM Code is required." };
    }
    if (dataValues.UOM === defaultCode) {
      return {
        isValid: false,
        message: `UOM Code cannot be saved as ${defaultCode}`,
      };
    }
    if (
      dataValues.BaseFactor &&
      !Number.isFinite(Number(dataValues.BaseFactor))
    ) {
      return {
        isValid: false,
        message: "Item Base UOM Factor should be a valid number.",
      };
    }
    return { isValid: true };
  };

  const handleClose = () => {
    onClose();
    setDataValues({});
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDataValues((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fetchCatalog = async () => {
    try {
      const response = await axios.get("/email/catalogs", {
        params: {
          connectionId: connectionId,
          dataType: artifactType,
          maxCount: 1,
          search: dataValues.UOM,
          parentCatalogId: itemId,
        },
      });

      const results = response.data.Records;
      return results.length > 0 ? response.data.Records[0] : null;
    } catch (error) {
      console.error("Error fetching new catalog: ", error);
      return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={"xl"}
      fullWidth
      PaperProps={{ style: { borderRadius: 15 } }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "var(--primary-main)",
          color: "var(--default-light)",
          fontSize: "24px",
          borderRadius: "15px 15px 0 0",
          padding: "16px 24px",
        }}
      >
        <div style={{ fontWeight: "var(--font-semi-bold)" }}>
          {"Add Catalog - Item UOM for " + (connectionName || "Connection")}
        </div>
        <IconButton
          onClick={handleClose}
          style={{ color: "var(--default-light)" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        style={{
          backgroundColor: "var(--disabled)",
          padding: "35px",
          minWidth: 400,
        }}
      >
        <Container>
          <Grid
            container
            spacing={2}
            rowSpacing={1}
            style={{ marginBottom: "20px", marginTop: "20px" }}
            sx={{ px: 20 }}
          >
            {/* changed from selector to a regular input */}
            <Grid item xs={4}>
              <Typography>Item Code</Typography>
              <TextField
                disabled
                variant="outlined"
                value={itemCode}
                sx={{ width: 250, marginTop: 1, marginBottom: 2 }}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography>
                UOM Code{" "}
                <Typography
                  component="span"
                  sx={{ color: "red", fontSize: "1.2rem", fontWeight: "bold" }}
                >
                  *
                </Typography>
              </Typography>
              <TextField
                variant="outlined"
                name="UOM"
                value={dataValues?.UOM || ""}
                onChange={handleChange}
                sx={{ width: 250, marginTop: 1, marginBottom: 2 }}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography>Item Base UOM Factor</Typography>
              <TextField
                variant="outlined"
                name="BaseFactor"
                value={dataValues?.BaseFactor || "1"}
                onChange={handleChange}
                sx={{ width: 250, marginTop: 1, marginBottom: 2 }}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography>Item Base UOM</Typography>
              <TextField
                variant="outlined"
                name="BaseUOM"
                value={dataValues?.BaseUOM || "1"}
                onChange={handleChange}
                sx={{ width: 250, marginTop: 1, marginBottom: 2 }}
              />
            </Grid>
          </Grid>
        </Container>
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <ShepButton variant="secondary" onClick={handleClose}>
          Cancel
        </ShepButton>
        <ShepButton
          onClick={async () => {
            const onSuccessfulSave = async () => {
              handleClose();
              if (onSuccess) {
                const newCatalog = await fetchCatalog();
                onSuccess(newCatalog);
              }
            };
            await handleAddCatalog(
              validateForm,
              onSuccessfulSave,
              dispatch,
              connectionId,
              artifactType,
              JSON.stringify({
                ...dataValues,
                connectionName,
                ItemCode: itemCode,
                ItemId: itemId,
              }),
            );
          }}
        >
          Add
        </ShepButton>
      </DialogActions>
    </Dialog>
  );
};

export default EmailAddItemUOMPopup;
